<template>
	<div>
		<div v-if="tickets.length" style='padding:10px;'>
			<div id='recherche'>
				<b-form>
					<b-button v-on:click.prevent="openModal($event.target)" class="createTicket" style="float:right;">Créer un ticket</b-button>
				</b-form>    
			</div>

			<div>
				<el-table v-loading="loading" ref="filterTable" :data="tickets" stripe style="width: 100%">
					<el-table-column prop="fk_socname" label="Entreprise" sortable width="400">
					</el-table-column>
					
					<el-table-column prop="ref" label="Réference" sortable width="120">
					</el-table-column>
					
					<el-table-column prop="type_label" label="Type de l'incident" width="180" :filters="optionsType" :filter-method="filterType" filter-placement="bottom-end">
					</el-table-column>
					
					<el-table-column prop="subject" label="Sujet">
					</el-table-column>

					<el-table-column prop="datec" label="Date" width="140">
					</el-table-column>

					<el-table-column prop="severity_label" label="Sévérité" width="140" :filters="optionsSeverite" :filter-method="filterSeverite" filter-placement="bottom-end">
					</el-table-column>

					<el-table-column prop="fk_statut_label" label="Statut" width="150" :filters="optionsStatut" :filter-method="filterStatut" filter-placement="bottom-end">
					</el-table-column>
				</el-table>

				<div v-if="totalRows>perPage">
					<el-pagination layout="prev, pager, next" :total="totalRows" :current-page="currentPage" :page-size="perPage" @current-change="changePage"></el-pagination>
				</div>
			</div>

			<div class='' id='infoTicket' style='width:23%; float:left; position:fixed; left:76.5%; display:none;height:75%;bottom:2%;background:white;'>
				<div style="font-size:20px;border:1px solid #e7e7e7;">
					<span style="padding:5px;">{{ "Ticket: "+titleCurrentTicket }}</span>
					<a class="" v-on:click.stop="masquerInfoTicket" style="margin-left:65%;"><span style="cursor:pointer;" class="fas fa-times" data-toggle="tooltip" title="Fermer"></span></a>
				</div>
				<div id='message' class='' style='width:100%;padding:1.5%;border:1px solid #e7e7e7;height:66%;'>
					<div class='conversationIncident'>
						<div style="height:98%;">
							<div id="messageInitial" style="max-height:100%;overflow:auto;">
								<span style="text-decoration: underline;">Message initial :</span>
								<br/>
								<span v-html="messageInitial"></span>
								<br/>
								<div v-if="ticketMessages.length">
									<div v-for="item in ticketMessages" :key="item.rowid">
										<div class="messageDestinateur" v-if="item.fk_user_action">
											<span v-html="item.message"></span>
										</div>
										<div class="messageDestinataire" v-else>
											<span v-html="item.message"></span>
										</div>
									</div>
								</div>
								<div v-else>
									<span>Aucun message sur ce ticket</span>
								</div>
							</div>
						</div>
						<form class='envoiMessage' @submit.prevent="sendMessageTicket" enctype='multipart/form-data'>
							<div class='messageClientFooter' style='position:fixed;bottom:2%;right:0.5%;left:76.5%;'>
								<wysiwyg v-model="formMessage.contenuMessage" />
								<!--<input type="file" name="myfile" id="myfile" multiple/>-->
								<button type='submit' class='btnEnvoiMessageIncident' style='width:40%;background:rgb(37,170,225);border:none;border-radius:8px;color:white;float:left;margin-left:30%;'>Envoyer</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>

		<div v-else class="container" style="max-width:75%;padding:10px;">
			<b-button v-on:click.prevent="openModal($event.target)" class="createTicket" variant="primary" style="float:right;">Créer un ticket</b-button>
			<h4>Il n'y a aucun ticket d'intervention.</h4>
		</div>

		<b-modal id="modalCreateTicket" @hide="resetModal" hide-footer>
		<creation-ticket/>
			<!-- <b-form @submit="sendTicketAdmin">
				<b-form-group id="input-group-site">
					<label class="labelCreateTicket">Client</label>
					<b-form-select id="input-site" class="inputCreateTicket" v-model="form.selectedSite" :options="optionsSites"></b-form-select>
				</b-form-group>

				<b-form-group id="input-group-type">
					<label class="labelCreateTicket">Type de demande</label>
					<b-form-select id="input-type" class="inputCreateTicket" v-model="form.selectedType" :options="optionsTypeCreate"></b-form-select>
				</b-form-group>

				<b-form-group id="input-group-severite">
					<label class="labelCreateTicket">Sévérité</label>
					<b-form-select id="input-severite" class="inputCreateTicket" v-model="form.selectedSeverite" :options="optionsSeveriteCreate"></b-form-select>
				</b-form-group>

				<b-form-group id="input-group-statut">
					<label class="labelCreateTicket">Sujet</label>
					<b-form-input type="text" id="input-sujet" class="inputCreateTicket" v-model="form.sujet"></b-form-input>
				</b-form-group>

				<b-form-group id="input-group-message">
					<label class="labelCreateTicket">Message</label>
					<wysiwyg v-model="form.messageTicket" id="input-message" class="inputCreateTicket"/>
				</b-form-group>

				<b-button id="sendTicket" type="submit" variant="primary">Envoyer ticket</b-button>
			</b-form> -->
		</b-modal>
	</div>   
</template>


<script>
import script from '../../../script/script_ticketSup.js';
import creationTicket from './CreationTicketAdmin.vue'

export default {
  data() {
    return {
      post: {},
      tickets:[],
      ticketMessages:[],
      messageInitial:"",
      currentTrack:"",
      titleCurrentTicket:"",
      currentPage: 1,
      perPage: 13,
      search:'',
      totalRows: "",
      formMessage:{
        contenuMessage:""
      },
      optionsType:[
        {value:'COM',text:"Question commerciale"},
        {value:'ISSUE',text:"Incident"},
        {value:'OTHER',text:"Autre"}
        ],
      optionsStatut:[
	  	{value:'0',text:"Non lu"},
        {value:'1',text:"Lu"},
        {value:'2',text:"Assigné"},
        {value:'3',text:"En cours"},
        {value:'5',text:"En attente de retour"},
        {value:'7',text:"En attente"},
        {value:'8',text:"Cloturé"},
      ],
      optionsSeverite:[
        {value:'LOW',text:"Bas"},
        {value:'NORMAL',text:"Normal"},
        {value:'HIGH',text:"Important"},
        {value:'BLOCKING',text:"Critique / Bloquant"}
      ],
      selectMode:'single',
      sites:[],
      optionsTypeCreate:[
        {value:'COM',text:"Question commerciale"},
        {value:'ISSUE',text:"Incident"},
        {value:'OTHER',text:"Autre"}
        ],
      optionsSeveriteCreate:[
        {value:'LOW',text:"Bas"},
        {value:'NORMAL',text:"Normal"},
        {value:'HIGH',text:"Important"},
        {value:'BLOCKING',text:"Critique / Bloquant"}
      ],
      form:{
        selectedType:'COM',
        selectedSeverite:'NORMAL',
        selectedSite:0,
        messageTicket:"",
        sujet:""
      },
      optionsSites:[],
      modalCreateTicket: { title: 'Création de nouveau ticket', content: '' },
      files:[],
	  selectedFile: null,
	  loading:true,
    }
  },
  mounted:async function(){
	  this.initialLoad()
  },
  methods: {
    verifyRight: script.verifyRight,
    loadingInfo: script.loadingInfo,
    loadTickets: script.loadTickets,
	filterTickets: script.filterTickets,
	getTotalTickets: script.getTotalTickets,
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    expandTicketInfoAdmin: script.expandTicketInfoAdmin,
    masquerInfoTicket: script.masquerInfoTicket,
    sendMessageTicket: script.sendMessageTicket,
    sendTicketAdmin: script.sendTicketAdmin,
    loadSites: script.loadSites,
    openModal(target){
      this.$root.$emit('bv::show::modal', 'modalCreateTicket',target);
	},
	filterStatut(value, row) {
		return row.fk_statut == value;
	},
	filterSeverite(value, row) {
		return row.severity_code == value;
	},
	filterType(value, row) {
		return row.type_code == value;
	},
	async changePage(evt){
		this.loading = true
		await this.loadTickets(evt-1, this.perPage)
		this.loading = false
	},
	async initialLoad(){
		this.verifyRight()
		this.loadSites()
		this.getTotalTickets()
		await this.loadTickets(this.currentPage-1, this.perPage)
		this.loading = false
	}
  },
  components: {
	creationTicket
  }
  
}
</script>

<style>
.sujet{
  width: 30%;
}

.entreprise{
  width:20%;
}

.reference{
  width: 8%;
}

.type{
  width: 13%;
}

.date{
  width: 10%;
}

.severite{
  width: 12%;
}

.statut{
width: 7%;
}

.selectFilterFloat{
  width: 15%;
  float:left;
}

.selectFilter{
  width: 15%; 
}

.conversationIncident{
  height: 100%;
}

.envoiMessage{
  height:35%;
}

.messageDestinateur{
  color:white;
  width:60%;
  float:right;
  background-color: rgb(36, 170, 225);
  padding: 14px;
  border-radius: 20px;
  margin-bottom:1em;
}

.messageDestinataire{
  width:60%;
  background-color: rgb(197,197,197);
  padding: 14px;
  border-radius: 20px;
  margin-bottom:1em;
  float: left;
}

.labelCreateTicket{
  width: 20%;
  float: left;
}

.inputCreateTicket{
  width: 80%;
}

#input-message{
  float:right;
}

#sendTicket{
  float:right;
}

#modalCreateTicket .contentFormCreateTicket{
	width: 100%;
}
</style>
